import React, { ReactElement } from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = ({ isWhite }: { isWhite?: boolean }): ReactElement => {
  return <CircularProgress sx={{ color: isWhite ? "white" : "#E1A731" }} />;
};

export default Loader;
